export default "__VITE_ASSET__20f54cf3__"